import { Box, Loader, Text } from '@wix/design-system'
import React, { FC, memo } from 'react'

export const WixStudioAvatar: FC<{ label?: string; loading?: boolean; background?: string; d?: string }> = memo(
  ({ label = '', loading = false, background = '#deff00', d = '30px' }) => (
    <Box background={background} width={d} height={d} verticalAlign="middle" align="center" borderRadius="100%">
      <Letter letter={label[0]} loading={loading} />
    </Box>
  ),
)

export const Letter: FC<{ letter?: string; loading?: boolean }> = memo(({ letter, loading }) => {
  if (loading) {
    return <Loader size="tiny" color="white" />
  }
  return (
    <Text size="small" weight="normal">
      {(letter || '').toUpperCase()}
    </Text>
  )
})
